import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    color: 'rgb(83,189,235)'
  }
}))

export default useStyles
